import { useEffect } from 'react'
import ReactGA from 'react-ga4'

const GOOGLE_ANALYTICS_ID_PROD = 'G-Q003PPV42B'

export const useGoogleAnalytics = (): void => {
  useEffect(() => {
    ReactGA.initialize([
      {
        trackingId: GOOGLE_ANALYTICS_ID_PROD,
        gtagOptions: { debug_mode: true },
      },
    ])
  }, [])
}
